import {AbstractAttributeFlowControl, SourceType} from './abstract-attribute-flow-control';
import {getSingleXMLTagValue} from './SynchronizationFunctions';

export abstract class AttributeFlow {
  src: SourceType[] = [];
  dest: string;

  protected constructor(private xmlTag: string) {}

  public isComplete(): boolean {
    return this.dest != null && this.src != null && this.src.length > 0;
  }

  public isEmpty(): boolean {
    return (
      (this.dest == null || this.dest.length === 0) && (this.src == null || this.src.length === 0)
    );
  }

  public generateJsForXml(): any {
    const flow = {
      src: {
        attr: [],
      },
      dest: undefined,
      scoping: '',
    };

    AbstractAttributeFlowControl.buildSourceXml(this, flow);

    if (this.dest != null) {
      flow.dest = this.dest;
    }

    return flow;
  }
  public generateXml(): string {
    const flow = this.generateJsForXml();

    return AbstractAttributeFlowControl.convertJsToXml({
      [this.xmlTag]: flow,
    });
  }
  public static createFromXml(xml: string, types = [ExportFlow, ImportFlow]): AttributeFlow {
    const obj: any = AbstractAttributeFlowControl.convertXmlToJs(xml);

    if (obj == null) {
      console.warn('Could not parse xml of attribute flow', xml);
      return null;
    }

    for (const flowClass of types) {
      if (obj.hasOwnProperty(flowClass.XML_TAG)) {
        const flowsArr = obj[flowClass.XML_TAG];
        if (!Array.isArray(flowsArr) || flowsArr.length !== 1) {
          console.warn('Could not parse xml of attribute flow', xml);
          return null;
        }
        return flowClass.createFromJs(flowsArr[0]);
      }
    }

    // root tag belongs to a different flow type (expected for shared attributes like PersistentFlow)
    return null;
  }
}

export class ImportFlow extends AttributeFlow {
  //"<import-flow><src><attr>sAMAccountName</attr></src><dest>co</dest><scoping></scoping></import-flow>"

  static readonly XML_TAG = 'import-flow';
  constructor() {
    super(ImportFlow.XML_TAG);
  }

  static createFromJs(root: any): ImportFlow {
    const flow = new ImportFlow();
    flow.dest = getSingleXMLTagValue(root, 'dest');
    AbstractAttributeFlowControl.parseSourceXml(root, flow);

    return flow;
  }

  public static createFromXml(xml: string): ImportFlow {
    return AttributeFlow.createFromXml(xml, [ImportFlow]) as ImportFlow;
  }
}

export class ExportFlow extends AttributeFlow {
  //"<export-flow allows-null="true"><src><attr>firstName</attr></src><dest>givenName</dest><scoping></scoping></export-flow>"

  allowsNull: boolean = false;
  static readonly XML_TAG = 'export-flow';

  constructor() {
    super(ExportFlow.XML_TAG);
  }

  isEmpty(): boolean {
    return super.isEmpty() && !this.allowsNull;
  }

  generateJsForXml(): any {
    const flow = super.generateJsForXml();
    flow.$ = {
      'allows-null': this.allowsNull,
    };
    return flow;
  }

  static createFromJs(root: any): ExportFlow {
    const flow = new ExportFlow();

    if (root['$']?.['allows-null']) {
      flow.allowsNull = root['$']['allows-null'].toLowerCase() === 'true';
    }

    flow.dest = getSingleXMLTagValue(root, 'dest');
    AbstractAttributeFlowControl.parseSourceXml(root, flow);

    return flow;
  }

  public static createFromXml(xml: string): ExportFlow {
    return AttributeFlow.createFromXml(xml, [ExportFlow]) as ExportFlow;
  }
}
